const bulkOrderButtons = document.createElement("div");
bulkOrderButtons.classList.add("pf-bulk-order-buttons");
bulkOrderButtons.innerHTML = `
    <button class="pf-bulk-button">
        <span> 1 </span>
        <span> unit </span>
    </button>
    <button class="pf-bulk-button">
        <span> 2 </span>
        <span> units </span>
    </button>
    <button class="pf-bulk-button">
        <span> 5 </span>
        <span> units </span>
    </button>
    <button class="pf-bulk-button">
        <span> 10 </span>
        <span> units </span>
    </button>
  `;


    const purchaseDetails = document.querySelector(".purchase-details");
    purchaseDetails.classList.add("pf-purchase-details")
    const quantityInput = purchaseDetails.querySelector("#quantity");
    // purchaseDetails.after(document.querySelector(".wk-button.wk-button--add "));
    if (!document.querySelector(".pf-bulk-order-buttons")) {
        purchaseDetails.prepend(bulkOrderButtons);
    }

    const bulkButtons = document.querySelectorAll(".pf-bulk-button");

    bulkButtons.forEach((button, index) => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            switch (index) {
                case 0: {
                    quantityInput.value = 1;
                    break;
                }
                case 1: {
                    quantityInput.value = 2;
                    break;
                }
                case 2: {
                    quantityInput.value = 5;
                    break;
                }
                case 3: {
                    quantityInput.value = 10;
                    break;
                }
            }
        });
    });

    function handleActiveClass() {
        const quantity = parseInt(quantityInput.value, 10);

        bulkButtons.forEach((button) => {
            button.classList.remove("pf-bulk-button--active");
        });

        if (quantity === 1) {
            bulkButtons[0]?.classList.add("pf-bulk-button--active");
        } else if (quantity >= 2 && quantity < 5) {
            bulkButtons[1]?.classList.add("pf-bulk-button--active");
        } else if (quantity >= 5 && quantity < 10) {
            bulkButtons[2]?.classList.add("pf-bulk-button--active");
        } else if (quantity >= 10) {
            bulkButtons[3]?.classList.add("pf-bulk-button--active");
        }
    }

    handleActiveClass();

    document.addEventListener("click", () => {
        handleActiveClass();
    });
